import { render, staticRenderFns } from "./RequestResponseDialog.vue?vue&type=template&id=0b90508d&scoped=true&lang=pug&"
import script from "./RequestResponseDialog.vue?vue&type=script&lang=js&"
export * from "./RequestResponseDialog.vue?vue&type=script&lang=js&"
import style0 from "./RequestResponseDialog.vue?vue&type=style&index=0&id=0b90508d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b90508d",
  null
  
)

export default component.exports